// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__aEvlV","createdSearch":"index_createdSearch__4tnUn","custom_table":"index_custom_table__NADEM"};